import {Box, Divider, Text} from '@chakra-ui/react';
import {useTranslation} from 'hooks';
import React from 'react';

const PromoGuideVideo: React.FC = () => {
  const {t, locale} = useTranslation();

  const getVideoSrc = () => {
    const supportedLocales = ['en', 'ro', 'ru'];
    const currentLocale = supportedLocales.includes(locale || '') ? locale : 'en';
    return `/promo_${currentLocale}.mp4`;
  };

  return (
    <>
      <Divider my="15px" />
      <Box>
        <Text align="center">{t('howToUsePromocode')}</Text>
        <Box mt={3} boxShadow="md" borderRadius="8px" overflow="hidden" border="1px solid #E2E8F0">
          <video
            src={getVideoSrc()}
            controls
            style={{width: '100%', borderRadius: '8px', background: '#000'}}
            poster="/food_pattern.webp"
            autoPlay
          >
            Your browser does not support the video playback.
          </video>
        </Box>
      </Box>
    </>
  );
};

export default PromoGuideVideo;
